export default "__VITE_ASSET__BIGTbMvV__"